import React, { ReactNode } from 'react';

type TabComponentProps = {
  children: JSX.Element[];
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
};

export function TabComponent({ children, activeTab, setActiveTab }: TabComponentProps) {
  return (
    <div>
      <div className="bg-white flex items-center justify-between pb-3 px-4 sticky top-60.5px w-full z-50 pt-1">
        {/* Tab Buttons */}
        {children &&
          children.map((child, index) => (
            <button
              key={child.props.name}
              type="button"
              className={`${
                activeTab === index ? 'border-rp-primary' : 'border-transparent text-rp-disabled'
              } border-t-4 font-rp-pn-semi-bold pt-1 text-md`}
              onClick={() => {
                setActiveTab(index);

                if (typeof child.props.onClickEvent === 'function') {
                  child.props.onClickEvent();
                }
              }}
            >
              {child.props.name}
            </button>
          ))}
      </div>

      {/* Tab Content */}
      <div>{children.map((child, index) => activeTab === index && child)}</div>
    </div>
  );
}

// This component only function is to wrap the TabComponent's children, so they're consistent.
// So you can use it like <TabComponent><Tab name='tabName'>Content</Tab></TabComponent>
type TabProps = {
  children: ReactNode;
  name: string;
  onClickEvent?: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Tab({ children, name, onClickEvent = undefined }: TabProps) {
  return <div data-testid={name}>{children}</div>;
}
